/// <amd-module name="Wit/Common/Utilities/Identity" />

import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { FeatureFlags } from "../Constants/FeatureFlags";

export function getAllowedIdentityTypes(
    pageContext: IVssPageContext,
    excludes?: {
        excludeUsers?: boolean;
        excludeGroups?: boolean;
        excludeServicePrincipals?: boolean;
    }
): string[] {
    const { excludeUsers, excludeGroups, excludeServicePrincipals } = excludes ?? {};
    const identityTypes = [];
    if (!excludeUsers) {
        identityTypes.push("user");
    }
    if (!excludeGroups) {
        identityTypes.push("group");
    }
    if (isFeatureFlagEnabled(pageContext, FeatureFlags.ServicePrincipalsAllowed) && !excludeServicePrincipals) {
        identityTypes.push("servicePrincipal");
    }
    return identityTypes;
}
